module.exports = __webpack_public_path__ + "img/76147.0e378c80.svg";